import declareEnterpriseView from "./DeclareEnterpriseView";

export default declareEnterpriseView;
